var render, staticRenderFns
import script from "./AssetGroupMarker.vue?vue&type=script&lang=js&"
export * from "./AssetGroupMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d2ed987')) {
      api.createRecord('5d2ed987', component.options)
    } else {
      api.reload('5d2ed987', component.options)
    }
    
  }
}
component.options.__file = "src/pages/Map/components/mapbox/AssetGroupMarker.vue"
export default component.exports